import {
  ADD_CARD_TO_BOARD,
  REMOVE_CARD,
  TOGGLE_CARD_ACTIVE,
  TOGGLE_HINT,
  RESET,
  CALCULATE_ODDS,
  CLOSE_HINT,
  SET_RULES,
  SET_PLAYERS_COUNT,
  SET_ACTIVE_FIELD,
  SET_CHOSEN_CARD,
  SHOW_HINT,
  GET_WINNER_HAND,
  UPDATE_ACTIVE_FIELD,
  SET_WINNER,
  SET_BOARD_CAROUSEL,
} from '../constants/actionTypes'

export const addCardToBoard = (rank, suit, active) => ({
  type: ADD_CARD_TO_BOARD,
  payload: {
    rank,
    suit,
    active,
  }
});

export const updateActiveField = () => ({
  type: UPDATE_ACTIVE_FIELD
});

export const removeCard = (rank, suit, type) => ({
  type: REMOVE_CARD,
  payload: {
    rank,
    suit,
    type,
  }
});

export const toggleCardActive = (rank, suit, active) => ({
  type: TOGGLE_CARD_ACTIVE,
  payload: {
    rank,
    suit,
    active,
  }
});

export const toggleHint = (type) => ({
  type: TOGGLE_HINT,
  payload: {
    type
  }
});

export const closeHint = (type) => ({
  type: CLOSE_HINT,
  payload: {
    type
  }
});

export const showHint = (type) => ({
  type: SHOW_HINT,
  payload: {
    type
  }
});

export const reset = () => ({
  type: RESET,
});

export const calculateOdds = (callback) => ({
  type: CALCULATE_ODDS,
  payload: {
    callback,
  }
});

export const getWinnerHand = () => ({
  type: GET_WINNER_HAND,
});

export const setRules = (id) => ({
  type: SET_RULES,
  payload: {
    id
  }
});

export const setPlayersCount = (id) => ({
  type: SET_PLAYERS_COUNT,
  payload: {
    id
  }
});

export const setActiveField = (type, id, isCardClicked) => ({
  type: SET_ACTIVE_FIELD,
  payload: {
    type,
    id,
    isCardClicked,
  }
});

export const setBoardCarousel = (payload) => ({
  type: SET_BOARD_CAROUSEL,
  payload
});

export const setChosenCard = (type, id) => ({
  type: SET_CHOSEN_CARD,
  payload: {
    type,
    id,
  }
});

export const setWinner = (type, winner) => ({
  type: SET_WINNER,
  payload: {
    winner,
  }
});